import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "../common/CommonButton/Button";

const NewProductDetailsCollection = (props: any) => {
  const { data, countryCode } = props;

  return (
    <section className="new-product-details-container">
      <div className="new-product-details-inner-wrapper">
        <div className="collection_wrapper">
          <div className="shop_now_product_cards">
            <div className="new-product-details-heading collection-heading">
              {data?.header}
            </div>

            <div className="product_card_wrapper">
              {data?.products?.data &&
                data?.products?.data.map((item: any, index: number) => {
                  return (
                    <div className="product_card" key={index}>
                      <div className="product_upper_section">
                        <div className="product_img_section">
                          <img
                            src={
                              item?.attributes?.feature_image?.data?.attributes
                                ?.url
                                ? item?.attributes?.feature_image?.data
                                    ?.attributes?.url
                                : ""
                            }
                            alt={`Duncan Taylor Whisky`}
                            className="bottle_img"
                          />
                        </div>
                        <div className="product_contains">
                          {/* <h3>The Octave</h3> */}
                          <h2>{item?.attributes?.name}</h2>
                          <h2>{item?.attributes?.age}</h2>
                          <h6>Cask No: {item?.attributes?.cask_number}</h6>
                        </div>
                      </div>
                      <div className="product_cart_section">
                        {item?.attributes?.cta?.link && (
                          <Button
                            btnText={"View Product"}
                            // btnText={item?.attributes?.cta?.title}
                            btnClass={"btn_buy_noe"}
                            btnLink={item?.attributes?.cta?.link}
                            linkOpenState={
                              item?.cta?.attributes?.open_in_new_tab
                            }
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewProductDetailsCollection;
